import { useMediaQuery } from "react-responsive";

// 질문결과페이지 미디어쿼리
// 상위 화면의 분기와 같은 정수 viewport를 사용해 확대 시 소수점 폭의 공백을 막는다.
const Desktop = ({ children }) => {
  const isDesktop = useMediaQuery({ minWidth: 1141, maxWidth: 10000 }, { width: window.innerWidth });
  return isDesktop ? children : null;
};

const LargeTablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 745, maxWidth: 1140 }, { width: window.innerWidth });
  return isTablet ? children : null;
};

const SmallTablet = ({ children }) => {
  const isTablet = useMediaQuery({ minWidth: 481, maxWidth: 744 }, { width: window.innerWidth });
  return isTablet ? children : null;
};

const Mobile = ({ children }) => {
  const isMobile = useMediaQuery({ maxWidth: 480 }, { width: window.innerWidth });
  return isMobile ? children : null;
};

export { Desktop, LargeTablet, SmallTablet, Mobile };

/*
Large Desktop / 10000-1141
Small Desktop, Large Tablet / 1140-745
Medium, Small Tablet / 744-481
Mobile / 480-320
*/

//  /* Large Desktops / 1920-1141 */
// @media (max-width: 1920px) and (min-width: 1141px) {
//   }

// /*Small Desktop, Large Tablet / 1140-745 */
// @media (max-width: 1140px) and (min-width: 745px) {
// }

// /* Medium, Small Tablet / 744-481 */
// @media (max-width: 744px) and (min-width: 481px) {
// }

// /* Mobile / 480-320 */
// @media (max-width: 480px) and (min-width: 320px) {
// }
